import { useEffect, useMemo, useState } from "react"
import { useLocation, Link, useHistory } from 'react-router-dom'
import { Button, Table } from 'antd'
import BreadCrumb from '../../component/BreadCrumb'
import { axiosTable, baseAxiosNoInfo } from "../../tool/axios"
import getPermission from '../../js/permission'

const { Column } = Table

export default function () {
    // 权限设置
    const permission: string[] = useMemo(() => {
        console.log(getPermission()) 
        return getPermission()
    }, [window.location.pathname])

    // 页面传递参数接收
    const Location: any = useLocation()
    const History: any = useHistory()

    // 采购单详情信息
    const [purchaseDetail, setPurchaseDetail] = useState<any>({})
    // 客餐食材
    const [customerFoodList, setCustomerFoodList] = useState<any>([])
    // 员工餐食材
    const [employeeFoodList, setEmployeeFoodList] = useState<any>([])
    // 调料品
    const [seasoningList, setSeasoningList] = useState<any>([])
    // 日用品
    const [dailyItemList, setDailyItemList] = useState<any>([])
    // 其它部门食材
    const [otherDeptFoodList, setOtherDeptFoodList] = useState<any>([])

    const fetch = () => {
        axiosTable('/cooking/purchase/detail', {
            params: {
                purchase_id: Location.state.purchase_id
            }
        }).then((res: any) => {
            const { 
                food_order_code, order_date, customer_order_code, customer_total_amount,
                employee_food_order_code, employee_total_amount, seasoning_order_code, seasoning_total_amount,
                daily_item_order_code, daily_item_total_amount, other_dept_food_order_code, other_dept_total_amount,
                customer_food_list, employee_food_list, seasoning_list, daily_item_list, other_dept_food_list
            } = res

            setPurchaseDetail({
                food_order_code, 
                order_date,
                customer_order_code, 
                customer_total_amount,
                employee_food_order_code,
                employee_total_amount,
                seasoning_order_code,
                seasoning_total_amount,
                daily_item_order_code,
                daily_item_total_amount,
                other_dept_food_order_code,
                other_dept_total_amount
            })

            setCustomerFoodList(customer_food_list)
            setEmployeeFoodList(employee_food_list)
            setSeasoningList(seasoning_list)
            setDailyItemList(daily_item_list)
            setOtherDeptFoodList(other_dept_food_list)
        })
    }

    useEffect(() => {
        fetch()
    }, [])

    // 导出采购单
    const exportPurchaseFile = () => {
        baseAxiosNoInfo('/cooking/purchase/detail/export', {
            params: {
                purchase_id: Location.state.purchase_id
            }
        }).then((res: any) => {
            window.open(res)
        })
    }

    // 导出采购单（加单）
    const exportPurchaseIncrFile = () => {
        baseAxiosNoInfo('/cooking/purchase/detail/incr_export', {
            params: {
                purchase_id: Location.state.purchase_id
            }
        }).then((res: any) => {
            window.open(res)
        })
    }

    // 菜单目录：膳食中心->厨房管理->食材采购管理->查看详情
    return (
        <div className="common-page">
            <BreadCrumb position={['膳食中心', '食材采购单详情']} />
            <div className="common-top-form">
                <div style={{display: 'flex', alignItems: 'center', marginBottom: '10px'}}>
                    <h1 style={{fontSize: '28px', fontWeight: 'bold',marginBottom: '0'}}>{Location.state.store_name}食材采购单详情</h1>
                    <Button type="primary" style={{margin: '0 20px'}} onClick={() => {
                        History.push({
                            pathname: '/food_purchase_edit',
                            state: {
                                ...Location.state,
                                order_date: purchaseDetail.order_date
                            }
                        })
                    }}>编辑</Button>
                    <Button type="primary" onClick={() => { exportPurchaseFile() }}>下载采购申请单</Button>
                    <Button type="primary" style={{margin: '0 20px'}} onClick={() => { exportPurchaseIncrFile() }}>下载采购申请单（加单）</Button>
                    <Button type="default" onClick={() => { window.history.go(-1) }} >返回</Button>
                </div>
                <div style={{display: 'flex', alignItems: 'center'}}>
                    <div className="form-item">
                        <span style={{fontWeight: 'bold', fontSize: '20px'}}>食材订单号：</span>
                        <span style={{fontSize: '20px', paddingRight: '15px'}}>{purchaseDetail.food_order_code}</span>
                    </div>
                    <div className="form-item">
                        <span style={{fontWeight: 'bold', fontSize: '20px'}}>客餐订单号：</span>
                        <span style={{fontSize: '20px', paddingRight: '15px'}}>{purchaseDetail.customer_order_code}</span>
                    </div>
                    <div className="form-item">
                        <span style={{fontWeight: 'bold', fontSize: '20px'}}>下单日期：</span>
                        <span style={{fontSize: '20px', paddingRight: '15px'}}>{purchaseDetail.order_date}</span>
                    </div>
                </div>
            </div>

            <div className="common-main">
                <div style={{display: 'flex', alignItems: 'center', marginBottom: '10px'}}>
                    <h1 style={{fontSize: '20px', fontWeight: 'bold',marginBottom: '0', marginRight: '20px'}}>客餐食材</h1>
                    <span style={{fontSize: '20px', paddingRight: '15px'}}>子订单号：</span>
                    <span style={{fontSize: '20px', paddingRight: '15px'}}>{purchaseDetail.customer_order_code}</span>
                </div>
                <Table 
                    dataSource={customerFoodList}
                    bordered={true}
                    pagination={false} 
                >
                    <Column title="物料编码"  dataIndex="food_item_code" key="food_item_code" />
                    <Column title="物料"  dataIndex="food_item_name" key="food_item_name" />
                    <Column title="客餐标准用量"  dataIndex="use_dosage" key="use_dosage" 
                        render={(text, record:any) => {
                            const { use_dosage, use_unit, order_num, order_unit } = record
                            return `${use_dosage}${use_unit} = ${order_num}${order_unit}`
                        }}
                    />
                    <Column title="食材份数" dataIndex="food_item_count" key="food_item_count" />
                    <Column title="客餐下单量" dataIndex="order_num" key="order_num" 
                        render={(text, record:any) => {
                            const { order_num, order_unit } = record
                            return `${order_num}${order_unit}`
                        }}
                    />
                    <Column title="陪护餐下单量" dataIndex="escort_num" key="escort_num" 
                        render={(text, record:any) => {
                            const { escort_num, escort_unit } = record
                            return `${escort_num}${escort_unit}`
                        }}
                    />
                    <Column title="下单总量" dataIndex="total_num" key="total_num" 
                        render={(text, record:any) => {
                            const { total_num, total_unit } = record
                            return `${total_num}${total_unit}`
                        }}
                    />
                    <Column title="食材价格" dataIndex="price" key="price" />
                    <Column title="备注" dataIndex="remark" key="remark" />
                </Table>
                <h1 style={{fontSize: '16px', paddingTop: '10px'}}>价格小计：{purchaseDetail.customer_total_amount | 0}</h1>
            </div>
            <div className="common-main">
                <div style={{display: 'flex', alignItems: 'center', marginBottom: '10px'}}>
                    <h1 style={{fontSize: '20px', fontWeight: 'bold',marginBottom: '0', marginRight: '20px'}}>员工餐食材</h1>
                    <span style={{fontSize: '20px', paddingRight: '15px'}}>子订单号：</span>
                    <span style={{fontSize: '20px', paddingRight: '15px'}}>{purchaseDetail.employee_food_order_code}</span>
                </div>
                <Table 
                    dataSource={employeeFoodList}
                    bordered={true}
                    pagination={false}
                >
                    <Column title="物料编码"  dataIndex="food_item_code" key="food_item_code" />
                    <Column title="物料"  dataIndex="food_item_name" key="food_item_name" />
                    <Column title="员工餐下单量"  dataIndex="order_num" key="order_num" 
                        render={(text, record:any) => {
                            const { order_num, order_unit } = record
                            return `${order_num}${order_unit}`
                        }}
                    />
                    <Column title="下单总量" dataIndex="total_num" key="total_num" 
                        render={(text, record:any) => {
                            const { total_num, total_unit } = record
                            return `${total_num}${total_unit}`
                        }}
                    />
                    <Column title="食材价格" dataIndex="price" key="price" />
                    <Column title="备注" dataIndex="remark" key="remark" />
                </Table>
                <h1 style={{fontSize: '16px', paddingTop: '10px'}}>价格小计：{purchaseDetail.employee_total_amount | 0}</h1>
            </div>
            <div className="common-main">
                <div style={{display: 'flex', alignItems: 'center', marginBottom: '10px'}}>
                    <h1 style={{fontSize: '20px', fontWeight: 'bold',marginBottom: '0', marginRight: '20px'}}>调料品</h1>
                    <span style={{fontSize: '20px', paddingRight: '15px'}}>子订单号：</span>
                    <span style={{fontSize: '20px', paddingRight: '15px'}}>{purchaseDetail.seasoning_order_code}</span>
                </div>
                <Table 
                    dataSource={seasoningList}
                    bordered={true}
                    pagination={false} 
                >
                    <Column title="物料编码"  dataIndex="food_item_code" key="food_item_code" />
                    <Column title="物料"  dataIndex="food_item_name" key="food_item_name" />
                    <Column title="下单量"  dataIndex="order_num" key="order_num" 
                        render={(text, record:any) => {
                            const { order_num, order_unit } = record
                            return `${order_num}${order_unit}`
                        }}
                    />
                    <Column title="下单总量" dataIndex="total_num" key="total_num" 
                        render={(text, record:any) => {
                            const { total_num, total_unit } = record
                            return `${total_num}${total_unit}`
                        }}
                    />
                    <Column title="食材价格" dataIndex="price" key="price" />
                    <Column title="备注" dataIndex="remark" key="remark" />
                </Table>
                <h1 style={{fontSize: '16px', paddingTop: '10px'}}>价格小计：{purchaseDetail.seasoning_total_amount | 0}</h1>
            </div>
            <div className="common-main">
                <div style={{display: 'flex', alignItems: 'center', marginBottom: '10px'}}>
                    <h1 style={{fontSize: '20px', fontWeight: 'bold',marginBottom: '0', marginRight: '20px'}}>日用品</h1>
                    <span style={{fontSize: '20px', paddingRight: '15px'}}>子订单号：</span>
                    <span style={{fontSize: '20px', paddingRight: '15px'}}>{purchaseDetail.daily_item_order_code}</span>
                </div>
                <Table 
                    dataSource={dailyItemList}
                    bordered={true}
                    pagination={false} 
                >
                    <Column title="物料编码"  dataIndex="food_item_code" key="food_item_code" />
                    <Column title="物料"  dataIndex="food_item_name" key="food_item_name" />
                    <Column title="下单量"  dataIndex="order_num" key="order_num" 
                        render={(text, record:any) => {
                            const { order_num, order_unit } = record
                            return `${order_num}${order_unit}`
                        }}
                    />
                    <Column title="下单总量" dataIndex="total_num" key="total_num" 
                        render={(text, record:any) => {
                            const { total_num, total_unit } = record
                            return `${total_num}${total_unit}`
                        }}
                    />
                    <Column title="食材价格" dataIndex="price" key="price" />
                    <Column title="备注" dataIndex="remark" key="remark" />
                </Table>
                <h1 style={{fontSize: '16px', paddingTop: '10px'}}>价格小计：{purchaseDetail.daily_item_total_amount | 0}</h1>
            </div>
            <div className="common-main">
                <div style={{display: 'flex', alignItems: 'center', marginBottom: '10px'}}>
                    <h1 style={{fontSize: '20px', fontWeight: 'bold',marginBottom: '0', marginRight: '20px'}}>其它部门食材</h1>
                    <span style={{fontSize: '20px', paddingRight: '15px'}}>子订单号：</span>
                    <span style={{fontSize: '20px', paddingRight: '15px'}}>{purchaseDetail.other_dept_food_order_code}</span>
                </div>
                <Table 
                    dataSource={otherDeptFoodList}
                    bordered={true}
                    pagination={false} 
                >
                    <Column title="物料编码"  dataIndex="food_item_code" key="food_item_code" />
                    <Column title="物料"  dataIndex="food_item_name" key="food_item_name" />
                    <Column title="下单量"  dataIndex="order_num" key="order_num" 
                        render={(text, record:any) => {
                            const { order_num, order_unit } = record
                            return `${order_num}${order_unit}`
                        }}
                    />
                    <Column title="下单总量" dataIndex="total_num" key="total_num" 
                        render={(text, record:any) => {
                            const { total_num, total_unit } = record
                            return `${total_num}${total_unit}`
                        }}
                    />
                    <Column title="食材价格" dataIndex="price" key="price" />
                    <Column title="备注" dataIndex="remark" key="remark" />
                </Table>
                <h1 style={{fontSize: '16px', paddingTop: '10px'}}>价格小计：{purchaseDetail.other_dept_total_amount | 0}</h1>
            </div>
        </div>
    )
}